import { KsToast } from '@aschehoug/kloss'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(KsToast, {
    duration: 4000,
  })
})
